const request = {
    invalid_input: '入力が無効です。 {{details}}',
    general: 'リクエストエラーが発生しました。',
};
export default request;
